<template>
  <div class="custom-select">
    <div class="cost-select" @click="openModal">
      <el-input :placeholder="title" :value="name" :disabled="disabled" :readonly="true" />
      <div class="clear-icon" v-if="name && !disabled">
        <i class="el-icon-circle-close" @click="clearFn"></i>
      </div>
    </div>
    <!-- 弹框 -->
    <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
  </div>
</template>

<script>
import SelectConfig from '@/found/components/select_org_cus_ter/select_config.vue';

export default {
  name: 'Dealer',
  props: {
    title: String,
    value: String,
    disabled: Boolean,
    getValue: Function,
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    SelectConfig,
  },
  data() {
    return {
      name: '',
    };
  },
  watch: {
    // 编码变化时同步名称（编辑/查看回显）
    value: {
      immediate: true,
      handler(v) {
        if (v && this.getValue) {
          this.name = this.getValue('customerName') || '';
        } else {
          this.name = '';
        }
      },
    },
  },
  methods: {
    // 点击输入框打开经销商弹窗
    openModal() {
      if (this.disabled || Object.keys(this.params).length === 0) {
        return;
      }
      const { idKey = 'customerCode' } = this.params;
      const params = {
        ...this.params,
        // 已选经销商回显勾选
        data: this.value ? [{ [idKey]: this.value }] : [],
        // 以弹窗内实际勾选为准，避免取消的行被回显数据合并回来
        noReset: true,
      };
      this.$refs.selectConfig.openSelectModal(params);
    },
    // 选择回调：交由表单统一带入编码、名称
    onGetSelect(val) {
      const row = (val || [])[0];
      this.name = (row && row.customerName) || '';
      this.$emit('change', row);
    },
    // 清除选择
    clearFn(e) {
      e.stopPropagation();
      this.name = '';
      this.$emit('change');
    },
  },
};
</script>

<style lang="less" scoped>
.cost-select {
  position: relative;

  /deep/ .el-input__inner {
    padding-right: 30px;
  }

  .clear-icon {
    width: 25px;
    height: 100%;
    position: absolute;
    right: 5px;
    top: 0;
    text-align: center;
    color: #c0c4cc;
    transition: all 0.3s;
    padding-top: 1px;
    display: none;

    .el-icon-circle-close {
      width: 100%;
      font-size: 14px;
      cursor: pointer;
      transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    }
  }

  &:hover {
    .clear-icon {
      display: block;
    }
  }
}
</style>
